<template>
	<div class="page_content">

		<div id="narrowYourResults" class="course-search-result-section">
			<div class="colummn-section">
				<div class="facets">
					<div class="main_head">
						<span class="icon-filter"></span>
						<span class="head_txt">Narrow Your Results</span>
					</div>

					<div class="facet_block_container">
						<div class="facet_block">
							<div class="head">
								<div class="checkbox">
									<input type="checkbox" @input="showCourseSectionTags = !showCourseSectionTags">
									<!-- <input @input="selectAllSemesters" type="checkbox">-->
								</div>
								<div class="head_txt">Course Section Tags</div>

							</div>
							<div class="folder-section">
								<div class="facet_row_container">
									<div v-if="showCourseSectionTags" class="course-tag-container">
									  <!-- <span> spring 2018 </span> -->
									  <template v-if="showCourseSectionTags" v-for="facet in formattedFacets.facetedCourseTags">
										<div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'facetedCourseTags')">{{facet.key}} [{{facet.doc_count}}]</input></div>
									  </template>
									  <!-- <input type="checkbox" v-model="" -->
									</div>
								</div>
							</div>
						</div>

						<div class="facet_block">
							<div class="head">
								<div class="checkbox">
									<input type="checkbox" :checked="showCourseFacets" @input="showCourseFacets = !showCourseFacets"></input>
								</div>
								<div class="head_txt">Courses</div>
								<!-- <input type="checkbox" @input="showCourseSectionTags = !showCourseSectionTags"> -->
							</div>
              <!-- filter -->
              <div class="folder-section">
                <div class="facet_row_container">
                  <div v-if="showCourseFacets" class="remaning-section">
                    <div v-if="courseSearchFlagMap.showYearCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseYear.length > 0 && courseSearchFlagMap.showYearCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showYearCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseYear.length > 0" class="subheading-row">Year</div>
                      <template v-for="facet in formattedFacets.catalogCourseYear">
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseYear')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showSemesterCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseTerm && formattedFacets.catalogCourseTerm.length > 0 && courseSearchFlagMap.showSemesterCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showSemesterCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseTerm && formattedFacets.catalogCourseTerm.length > 0" class="subheading-row">Semester</div>
                      <template v-for="facet in formattedFacets.catalogCourseTerm">
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseTerm')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showDepartmentCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseDepartment.length > 0 && courseSearchFlagMap.showDepartmentCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showDepartmentCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseDepartment.length > 0" class="subheading-row">Department</div>
                      <template v-for="facet in formattedFacets.catalogCourseDepartment">
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseDepartment')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showSubjectCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseSubject.length > 0 && courseSearchFlagMap.showSubjectCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showSubjectCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseSubject.length > 0" class="subheading-row">Subject</div>
                      <template v-for="facet in formattedFacets.catalogCourseSubject" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseSubject')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showDivisionCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseDivision.length > 0 && courseSearchFlagMap.showDivisionCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showDivisionCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseDivision.length > 0" class="subheading-row">Division</div>
                      <template v-for="facet in formattedFacets.catalogCourseDivision" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseDivision')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showUnitsCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseCredit.length > 0 && courseSearchFlagMap.showUnitsCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showUnitsCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseCredit.length > 0" class="subheading-row">Credits</div>
                      <template v-for="facet in formattedFacets.catalogCourseCredit" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseCredit')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showInstructorCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseInstructor.length > 0 && courseSearchFlagMap.showInstructorCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showInstructorCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseInstructor.length > 0" class="subheading-row">Instructors</div>
                      <template v-for="facet in formattedFacets.catalogCourseInstructor" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseInstructor')">{{processIntructorName(facet.key)}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showTimeCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseTime.length > 0 && courseSearchFlagMap.showTimeCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showTimeCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseTime.length > 0" class="subheading-row">Time</div>
                      <template v-for="facet in formattedFacets.catalogCourseTime" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input="facetSelected(facet, 'catalogCourseTime')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showCourseSearchFlagCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseFlag.length > 0 && courseSearchFlagMap.showCourseSearchFlagCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showCourseSearchFlagCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseFlag.length > 0" class="subheading-row">Course Flags</div>
                      <template v-for="facet in formattedFacets.catalogCourseFlag" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseFlag')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showBlockCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseBlock.length > 0 && courseSearchFlagMap.showBlockCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showBlockCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseBlock.length > 0" class="subheading-row">Block</div>
                      <template v-for="facet in formattedFacets.catalogCourseBlock" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseBlock')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>

                    <div v-if="courseSearchFlagMap.showGradeLevelCriteria.enabled">
                      <div v-if="formattedFacets.catalogCourseGradeLevel.length > 0 && courseSearchFlagMap.showGradeLevelCriteria.label" class="subheading-row">
                        {{courseSearchFlagMap.showGradeLevelCriteria.label}}
                      </div>
                      <div v-else-if="formattedFacets.catalogCourseGradeLevel.length > 0" class="subheading-row">Grade Level</div>
                      <template v-for="facet in formattedFacets.catalogCourseGradeLevel" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input.stop="facetSelected(facet, 'catalogCourseGradeLevel')">{{facet.key}} [{{facet.doc_count}}]</input></div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
						</div>

					</div>
				</div>

				<div class="mid-panel datatable">
					<div class="list-header">
						<div class="float-left left-container">
							<div id="resultsHeader">
							  <b-dropdown id="ddown1" text="Dropdown Button" class="m-md-2">
								<template slot="button-content" v-if="isListView">
								  <span class="fas fa-bars"></span>
								</template>
								<template slot="button-content" v-else>
								  <span class="fas fa-bars"></span>
								</template>
								<b-dropdown-header><span class="view-title">change view to</span>
								    <button class="btn_close" aria-label="close" @click="closeChangeView">
                                         <span class="ic-close"></span>
                                     </button>
								</b-dropdown-header>
								<b-dropdown-item @click="listViewClicked">List View</b-dropdown-item>
								<b-dropdown-item @click="gridViewClicked">Grid View</b-dropdown-item>
							  </b-dropdown>
							</div>
						</div>
						<div class="right-container">
							<div class="number-of-item" tabindex="0">
								<b-dropdown id="ddown-buttons" :text="''+size" :options="sizeOptions" aria-label="number of item">
									  <template v-for="(option, index) in sizeOptions">
										  <b-dropdown-divider v-if="index > 0"></b-dropdown-divider>
										  <b-dropdown-item @click="changeSize(option)">{{option}}</b-dropdown-item>
									  </template>
								</b-dropdown>
							</div>
							<div class="pagination btn_container pagination_sty3">
                                <button type="button" class="btn btn_trans" @click="firstPage" :title="$t('firstPageLabel')" :aria-label="$t('firstPageLabel')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
								<button type="button" class="btn btn_trans" @click="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
								<span class="current-page">{{pageNumber}}</span>
								<button type="button" class="btn btn_trans" @click="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                                <button type="button" class="btn btn_trans" @click="lastPage" :title="$t('lastPageLabel')" :aria-label="$t('lastPageLabel')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
							</div>
						</div>
					</div>

                    <!--<div v-if="loading">Loading Results...</div>-->
                    <span v-if='!loading && formattedResults.length === 0' class="course-search-no-result">No results found!</span>

					<div id="listViewResults" class="list-view-section" v-if='isListView'>
					  <template v-if="formattedResults.length > 0" v-for="course in formattedResults">
						<div class="item-row">
							<div class="header-row">
								<div class="add-to-stream-column">
									<div class="course-title">
										<span class="icon icon-course"></span>
										<span class="title-name" @click.stop="navigateToCourse(course)" tabindex="0">{{course.title}}</span>
									</div>
                  <!-- TODO: :disabled.sync="... || stream.isLocked" -->
									<b-dropdown v-if="addToStreamFlagMap.showRemove.enabled"
                              :disabled.sync="course.isAddedToStream || isPlanningStreamLocked" class="add-item" no-caret>
										<template slot="button-content">
										  <span class="fa fa-ellipsis-v"></span>
										</template>
										<b-dropdown-item @click='addCourseToStream(course)'>add to my stream</b-dropdown-item>
									</b-dropdown>
								</div>
							</div>
						    <div class="description-section">
								<div class="description-column">
								  <div class="course-desc">
									<span class="fas fa-bars icon"></span>
									<span class="title_new ace_sec_txt">
                                          <v-clamp class="title_txt" autoresize :max-lines="3">{{ course.description }}</v-clamp>
                                    </span>
								  </div>
								  <div class="course-content">
									<ul>
										<li v-if="courseSearchFlagMap.showSectionOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showSectionOnResult.label">{{courseSearchFlagMap.showSectionOnResult.label}}: {{course.section}}</span>
                                          <span v-else="courseSearchFlagMap.showSectionOnResult.label">Section: {{course.section}}</span>
                                        </li>
										<li v-if="courseSearchFlagMap.showCRNOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showCRNOnResult.label">{{courseSearchFlagMap.showCRNOnResult.label}}: {{course.crn}}</span>
                                          <span v-else="courseSearchFlagMap.showCRNOnResult.label">CRN: {{course.crn}}</span>
                                        </li>
										<li v-if="courseSearchFlagMap.showMeetingDaysOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showMeetingDaysOnResult.label">{{courseSearchFlagMap.showMeetingDaysOnResult.label}}: {{course.days}}</span>
                                          <span v-else="courseSearchFlagMap.showMeetingDaysOnResult.label">Meeting Days: {{course.days}}</span>
                                        </li>
										<li v-if="courseSearchFlagMap.showMeetingTimesOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showMeetingTimesOnResult.label">{{courseSearchFlagMap.showMeetingTimesOnResult.label}}: {{course.times}}</span>
                                          <span v-else="courseSearchFlagMap.showMeetingTimesOnResult.label">Meeting Times: {{course.times}}</span>
                                        </li>
										<li v-if="courseSearchFlagMap.showEnrollmentOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showEnrollmentOnResult.label">{{courseSearchFlagMap.showEnrollmentOnResult.label}}: {{course.enrollment}}</span>
                                          <span v-else="courseSearchFlagMap.showEnrollmentOnResult.label">Enrollment: {{course.enrollment}}</span>
                                        </li>
										<li v-if="courseSearchFlagMap.showCreditOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showCreditOnResult.label">{{courseSearchFlagMap.showCreditOnResult.label}}: {{course.creditHour}}</span>
                                          <span v-else="courseSearchFlagMap.showCreditOnResult.label">Credit: {{course.creditHour}}</span>
                                        </li>
										<li v-if="courseSearchFlagMap.showRoomInformationOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showRoomInformationOnResult.label">{{courseSearchFlagMap.showRoomInformationOnResult.label}}: {{course.roomInformation}}</span>
                                          <span v-else="courseSearchFlagMap.showRoomInformationOnResult.label">Room Information: {{course.roomInformation}}</span>
                                        </li>
										<li v-if="courseSearchFlagMap.showSpecialInstructionsOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showSpecialInstructionsOnResult.label">{{courseSearchFlagMap.showSpecialInstructionsOnResult.label}}: {{course.specialInstructions}}</span>
                                          <span v-else="courseSearchFlagMap.showSpecialInstructionsOnResult.label">{{course.specialInstructions}}</span>
                                        </li>
                                        <li class="block" v-if="courseSearchFlagMap.showBlockOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showBlockOnResult.label">{{courseSearchFlagMap.showBlockOnResult.label}}: {{(course.block) ? course.block.toString() : '--'}}</span>
                                          <span v-else="courseSearchFlagMap.showBlockOnResult.label">Block: {{(course.block) ? course.block.toString() : '--'}}</span>
                                        </li>
                                        <li class="block" v-if="courseSearchFlagMap.showGradeLevelOnResult.enabled" tabindex="0">
                                          <span v-if="courseSearchFlagMap.showGradeLevelOnResult.label">{{courseSearchFlagMap.showGradeLevelOnResult.label}}: {{(course.gradeLevel) ? course.gradeLevel.toString() : '--'}}</span>
                                          <span v-else="courseSearchFlagMap.showGradeLevelOnResult.label">Grade Level: {{(course.gradeLevel) ? course.gradeLevel.toString() : '--'}}</span>
                                        </li>
									</ul>
								  </div>
								</div>
								<div class="thumbnail-section" tabindex="0">
									<div class="thumbnail_default icon-course"></div>
								</div>

							</div>
						</div>
					  </template>
					</div>

					<div id="gridViewResults" class="grid-view-section" v-else>
					  <template v-if="formattedResults.length > 0" v-for="course in formattedResults">
						<div class="grid-box">
							<div class="entity-container">
							  <b-dropdown :disabled.sync="course.isAddedToStream || !userStreams || userStreams.length < 1" class="add-item" no-caret>
								<template slot="button-content">
								  <span class="fa fa-ellipsis-v"></span>
								</template>
								<b-dropdown-item @click='addCourseToStream(course)'>add to my stream</b-dropdown-item>
							  </b-dropdown>
							  <div class="thumbnail" tabindex="0">
								<span class="icon-course icon"></span>
							  </div>
							  <div :id="course.uuid" class="title-row">
								<span class="title" @click.stop="navigateToCourse(course)" tabindex="0">{{course.title}}</span>
							  </div>
							</div>
						    <div id="grid-view-popover" class="grid-view-popover"></div>
							<b-popover :target="course.uuid"
										 :title="course.title"
										 triggers="hover focus"
										 container="grid-view-popover">
								<span class="course-desc">{{course.description}}</span>

								<span v-if="courseSearchFlagMap.showSectionOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showSectionOnResult.label">{{courseSearchFlagMap.showSectionOnResult.label}}: {{course.section}}</span>
                                  <span v-else>Section: {{course.section}}</span>
                                </span>
								<span v-if="courseSearchFlagMap.showCRNOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showCRNOnResult.label">{{courseSearchFlagMap.showCRNOnResult.label}}: {{course.crn}}</span>
                                  <span v-else="courseSearchFlagMap.showCRNOnResult.label">CRN: {{course.crn}}</span>
                                </span>
								<span v-if="courseSearchFlagMap.showMeetingDaysOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showMeetingDaysOnResult.label">{{courseSearchFlagMap.showMeetingDaysOnResult.label}}: {{course.days}}</span>
                                  <span v-else="courseSearchFlagMap.showMeetingDaysOnResult.label">Meeting Days: {{course.days}}</span>
                                </span>
								<span v-if="courseSearchFlagMap.showMeetingTimesOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showMeetingTimesOnResult.label">{{courseSearchFlagMap.showMeetingTimesOnResult.label}}: {{course.times}}</span>
                                  <span v-else="courseSearchFlagMap.showMeetingTimesOnResult.label">Meeting Times: {{course.times}}</span>
                                </span>
								<span v-if="courseSearchFlagMap.showEnrollmentOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showEnrollmentOnResult.label">{{courseSearchFlagMap.showEnrollmentOnResult.label}}: {{course.enrollment}}</span>
                                  <span v-else="courseSearchFlagMap.showEnrollmentOnResult.label">Enrollment: {{course.enrollment}}</span>
                                </span>
								<span v-if="courseSearchFlagMap.showCreditOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showCreditOnResult.label">{{courseSearchFlagMap.showCreditOnResult.label}}: {{course.creditHour}}</span>
                                  <span v-else="courseSearchFlagMap.showCreditOnResult.label">Credit: {{course.creditHour}}</span>
                                </span>
								<span v-if="courseSearchFlagMap.showRoomInformationOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showRoomInformationOnResult.label">{{courseSearchFlagMap.showRoomInformationOnResult.label}}: {{course.roomInformation}}</span>
                                  <span v-else="courseSearchFlagMap.showRoomInformationOnResult.label">Room Information: {{course.roomInformation}}</span>
                                </span>
								<span v-if="courseSearchFlagMap.showSpecialInstructionsOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showSpecialInstructionsOnResult.label">{{courseSearchFlagMap.showSpecialInstructionsOnResult.label}}: {{course.specialInstructions}}</span>
                                  <span v-else="courseSearchFlagMap.showSpecialInstructionsOnResult.label">{{course.specialInstructions}}</span>
                                </span>
                                <span v-if="courseSearchFlagMap.showBlockOnResult.enabled" class="content-column">
                                  <span v-if="courseSearchFlagMap.showBlockOnResult.label">{{courseSearchFlagMap.showBlockOnResult.label}}: {{course.block}}</span>
                                  <span v-else="courseSearchFlagMap.showBlockOnResult.label">{{course.block}}</span>
                                </span>
							</b-popover>
						</div>
					  </template>
					</div>

				</div>

				<div v-if="addToStreamFlagMap.showRemove.enabled" class="right-facet">
					 <add-to-stream></add-to-stream>
				</div>

			</div>
		</div>

		<div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

	</div>
</template>

<script>
  import '../../../assets/module/css/discover/courseSearch.min.css'
  import { mapActions, mapState } from 'vuex'
  import AddToStream from '../../search/components/AddToStream'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import VClamp from 'vue-clamp'

  export default {
    name: 'course-search-results',
    components: {
      AddToStream,
      VClamp
    },
    props: ['isPlanning', 'timestamp'],
    data: () => {
      return {
        loading: false,
        selectAllFolders: true,
        folders: [],
        allFolders: [],
        foldersSelected: [],
        userId: '',
        userRole: localStorage.getItem('userrole'),
        assetType: [],
        assetTypeSelected: [],
        courseType: [],
        courseTypeSelected: [],
        filter: {},
        indexes: [
          {
            text: 'Course [0]',
            value: 'DeliveryContext',
            checked: true
          },
          {
            text: 'Asset [0]',
            value: 'LearningContent',
            checked: true
          }
        ],
        indexesSelected: [],
        allIndexes: ['deliverycontext'],
        myContent: [
          {
            text: 'Owned by Me',
            value: 'myContent',
            checked: true
          },
          {
            text: 'Shared with Me',
            value: 'sharedContent',
            checked: true
          }
        ],
        myContentSelected: ['myContent', 'sharedContent'],
        source: [
          'uuid',
          'title',
          'description',
          'creationTime',
          'lastUpdatedTime',
          'type',
          'ancestor',
          'owningLibraryId',
          'ownerName',
          'ownerId',
          'originUuid',
          'thumbnailURIList',
          'appliedTagMap',
          'facetedCourseTags',
          'maxSeats',
          'currentSeats',
          'roomInformation',
          'meetingDays',
          'meetingFromTime',
          'meetingToTime',
          'specialInstructions',
          'crn',
          'division',
          'department',
          'departmentCode',
          'subject',
          'subjectCode',
          'level',
          'maxCredit',
          'minCredit',
          'creditHour',
          'prerequisites',
          'corequisities',
          'catalogCourseId',
          'instructorNames',
          'num',
          'meetingDaysRaw',
          'meetingDaysFormatted',
          'termCode',
          'timeSlots',
          'courseFlags',
          'catalogId',
          'level',
          'courseMajors',
          'courseMajorCodes',
          '_score'
        ],
        sizeOptions: [ 10, 50, 100 ],
        ignoreFolderWatch: false,
        ignoreCourseWatch: false,
        ignoreAssetWatch: false,
        destination: {},
        copyMoveDestinationFolders: [],
        searchText: '',
        isListView: true,
        showCourseSectionTags: false,
        showCourseFacets: true,
        courseFlags: [],
        coursesInStream: [],
        selectedFacetNames: [],
        facetFieldMap: {
          facetedCourseTags: 'facetedCourseTags.tagNames.keyword',
          catalogCourseDepartment: 'department',
          catalogCourseSubject: 'subject',
          catalogCourseDivision: 'division',
          catalogCourseInstructor: 'instructorNames',
          catalogCourseCredit: 'creditHour.keyword',
          catalogCourseTime: 'timeSlots.keyword',
          catalogCourseFlag: 'courseFlags.keyword',
          catalogCourseLevel: 'level.keyword',
          catalogCourseBlock: 'block',
          catalogCourseGradeLevel: 'gradeLevel.keyword',
          catalogCourseYear: 'academicYear',
          catalogCourseTerm: 'academicTerm'
        },
        lockStreamFlagName: 'lockStream'
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      ...mapActions([
        'populateCourses',
        'populateAllStreamCourses',
        'loginToGoogleCalendar',
        'executeAdvancedSearch',
        'refreshAdvancedSearchResults',
        'loadAllLibraryForUser',
        'loadLibraryPositionMapping',
        'updateFrom',
        'updatePageNumber',
        'updateSize',
        'addToMyStream',
        'addStreamCourse',
        'loadLogDashboardActivity'
      ]),
      closeChangeView () {
        $('.dropdown-menu, #ddown1').removeClass('show')
      },
      loadData () {
        this.userId = localStorage.getItem('userid')
        this.loadLibraryPositionMapping()
        this.initializeSearchFilter()
        const reload = !this.$route.params.isPlanning
        if (reload) {
          this.setupUserLibraries()
        }
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      notifyWarning (text) {
        this.$notify({
          group: 'notify',
          type: 'warning',
          title: '',
          text: text
        })
      },
      joinListWithCommas (stringList) {
        let str = []

        for (var i = 0; i < stringList.length; i++) {
          if (str.length === 0) {
            str = stringList[i]
          } else {
            str = str + ',' + stringList[i]
          }
        }
        return str
      },
      onShown () {
        this.executeSearch()
      },
      buildFilterTermClause (arrayName, array) {
        let clause = {
          'terms': {}
        }
        clause.terms[arrayName] = array
        return clause
      },
      filterForQuery () {
        let formattedFilter = []
        let filter = this.filter
        let buildTermClause = this.buildFilterTermClause
        Object.keys(filter).forEach(key => {
          let array = filter[key]
          if (array && array.length > 0) {
            formattedFilter.push(buildTermClause(key, array))
          }
        })
        return formattedFilter
      },
      buildFacet (field, size, facetName, order) {
        return {
          'aggs': {
            'termObj': {
              'terms': {
                'field': field,
                'size': size,
                'order': order || {'_key': 'asc'}
              }
            }
          },
          'filter': this.getFacetFilter(facetName)
        }
      },
      executeSearch (resetFacets) {
        // construct facets
        let buildFacet = this.buildFacet
        // let getFacetFilter = this.getFacetFilter
        let facets = {
          /*
          'facetedCourseTags': {
            "nested" : {
                "path" : "facetedCourseTags"
            },
            'aggs': {
              'termObj': {
                'terms': {
                  'field': 'facetedCourseTags.tagNames.keyword',
                  'size': 100
                }
              }
            },
            'filter': getFacetFilter('facetedCourseTags.tagNames')
          },
          */
          'facetedCourseTags': buildFacet('facetedCourseTags.tagNames.keyword', 100, 'facetedCourseTags.tagNames'),
          'catalogCourseDivision': buildFacet('division', 100, 'catalogCourseDivision'),
          'catalogCourseDepartment': buildFacet('department', 100, 'catalogCourseDepartment'),
          'catalogCourseSubject': buildFacet('subject', 100, 'catalogCourseSubject'),
          'catalogCourseInstructor': buildFacet('instructorNames', 100, 'catalogCourseInstructor'),
          'catalogCourseCredit': buildFacet('creditHour.keyword', 100, 'catalogCourseCredit'),
          'catalogCourseTime': buildFacet('timeSlots.keyword', 100, 'catalogCourseTime', {'_key': 'desc'}),
          'catalogCourseFlag': buildFacet('courseFlags.keyword', 100, 'catalogCourseFlag'),
          'catalogCourseLevel': buildFacet('level.keyword', 50, 'catalogCourseLevel'),
          'catalogCourseBlock': buildFacet('block', 50, 'catalogCourseBlock'),
          'catalogCourseGradeLevel': buildFacet('gradeLevel.keyword', 50, 'catalogCourseGradeLevel'),
          'catalogCourseYear': buildFacet('academicYear', 50, 'catalogCourseYear'),
          'catalogCourseTerm': buildFacet('academicTerm', 50, 'catalogCourseTerm')
        }

        let filter = this.filterForQuery()
        let loadSearchResults = resetFacets === true ? this.refreshAdvancedSearchResults : this.executeAdvancedSearch
        const searchInput = {
          source: this.formattedSource,
          from: this.from,
          size: this.size,
          indexList: this.formattedIndexList,
          libraryList: this.formattedLibraryList,
          privateLibraryList: this.privateLibraryList,
          publicLibraryList: this.publicLibraryList,
          userId: this.userId,
          facets: facets,
          filter: filter,
          facetNames: this.allFacetNames,
          selectedFacetNames: this.selectedFacetNames
        }
        loadSearchResults(searchInput).then(response => {
          this.hideLoader()
        })
      },
      getFacetFilter (facetName) {
        var facetFilterObj = {
          'bool': this.originUuidCheck()
        }
        if (this.filter && facetName && !this.selectedFacetNames.includes(facetName)) {
          // facetFilterObj['and'] = facetFilterObj['and'].concat(this.filterForQuery())
          facetFilterObj.bool.must = facetFilterObj.bool.must.concat(this.filterForQuery())
        }
        return facetFilterObj
      },
      originUuidCheck () {
        var originUuidCheck = {
          'must': [],
          'must_not': {
            'exists': {
              'field': 'originUuid'
            }
          }
        }
        return originUuidCheck
      },
      loadUserInfo () {
        return new Promise((resolve, reject) => {
          let uObj = this.userObj
          if (uObj.userPreferences === undefined) {
            uObj = JSON.parse(localStorage.getItem('userobj'))
          }
          resolve(uObj)
        })
      },
      setupUserLibraries () {
        this.showLoader()
        var userPreferences = {}
        this.loadUserInfo().then(res => {
          userPreferences = res.userPreferences
          this.loadAllLibraryForUser().then(libraries => {
            this.folders = []
            this.allFolders = []
            this.foldersSelected = []
            this.publicLibraryList = []
            this.privateLibraryList = []
            this.ignoreFolderWatch = true
            var learningSpaces = this.sortLibrariesIntoStandardOrder(libraries)
            if (learningSpaces && learningSpaces.length > 0) {
              var selectedLearningSpaces = userPreferences.learningSpaces
              for (var i = 0; i < learningSpaces.length; i++) {
                let learningSpace = learningSpaces[i]
                const category = learningSpace.category
                if (category === 'Institute_Public') {
                  this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + '[0]'})
                  this.ignoreFolderWatch = true
                  this.allFolders.push(learningSpace.uuid)
                  if (selectedLearningSpaces.includes(learningSpace.uuid)) {
                    this.foldersSelected.push(learningSpace.uuid)
                  }
                  if (category !== 'Institute' && category !== 'User_Private') {
                    this.publicLibraryList.push(learningSpace.uuid)
                  }
                  if (category === 'User_Private') {
                    this.privateLibraryList.push(learningSpace.uuid)
                  }
                }
                let permission = learningSpace.acelist[0].permission
                if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
                  this.copyMoveDestinationFolders.push(learningSpace)
                }
              }
              this.executeSearch()
            }
          })
        })
      },
      sortLibrariesIntoStandardOrder (libraries) { // TODO remove if not needed, seems to have no effect on library order
        var sortedLibraryList = []
        for (var attr in this.libraryPositionMapping) {
          var value = this.libraryPositionMapping[attr]
          for (var i = 0; i < libraries.length; i++) {
            var library = libraries[i]
            if (this.libraryMatches(library, value)) {
              sortedLibraryList.push(library)
            }
          }
        }
        return sortedLibraryList
      },
      libraryMatches (library, value) {
        if (library.category === 'LearningSpace') {
          if (library.title === 'Shared With Me') {
            if (value === 'Shared') {
              return true
            }
          } else {
            if (value === 'Global') {
              return true
            }
          }
        }
        return library.category.indexOf(value) !== -1
      },
      listViewClicked () {
        this.isListView = true
      },
      gridViewClicked () {
        this.isListView = false
      },
      getFormattedDayAndTimeStrings (course) {
        let days = ''
        let times = ''

        if (course.meetingDaysRaw) {
          course.meetingDaysRaw.forEach(function (meetingDay) {
            days += (meetingDay.day) ? (meetingDay.day + '; ') : ''
            times += (meetingDay.meetingFromTime) ? (meetingDay.meetingFromTime + ' - ' + meetingDay.meetingToTime + '; ') : ''
          })
        }
        return {days: days, times: times}
      },
      buildTermsFilter (field, value) {
        let filter = {
          'terms': {}
        }
        filter.terms[field] = [value]
        return filter
      },
      filterValueIndex (filterValue) {
        let filterIndex = -1
        let filter = this.filter
        if (!filter || !filter.length || filter.length < 0) {
          return -1
        }
        filter.forEach((clause) => {
          let clauseArray = clause.terms[Object.keys(clause.terms)[0]]
          if (clauseArray && clauseArray.length) {
            clauseArray.forEach((value, i) => {
              if (value === filterValue) {
                filterIndex = i
              }
            })
          }
        })
        return filterIndex
      },
      facetSelected (facet, facetName) {
        const fieldName = this.facetFieldMap[facetName]
        const fieldValue = facet.key
        if (this.isTermFilterSelected(facet, fieldName)) {
          // remove filter term
          this.filter[fieldName] = this.filter[fieldName].filter(v => v !== fieldValue)

          // remove facetName if list is filter clause is empty
          if (this.selectedFacetNames.includes(facetName) && this.filter[fieldName].length === 0) {
            this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== facetName)
          }
          // this.setFacetSelected({facet: facet, isSelected: false, facetName: facetName})
        } else {
          this.filter[fieldName].push(fieldValue)
          if (!this.selectedFacetNames.includes(facetName)) {
            this.selectedFacetNames.push(facetName)
          }
          // this.setFacetSelected({facet: facet, isSelected: true, facetName: facetName})
        }

        this.updateFrom(0)
        this.updatePageNumber(1)
        this.executeSearch()
      },
      selectAllSemesters () {
        // TODO iterate over ever facetedCourseTags.tagNames and set an isSelected prop for v-model
      },
      changeSize (option) {
        this.updateSize(option)
        this.updateFrom(0)
        this.updatePageNumber(1)
        this.executeSearch()
      },
      prevPage () {
        if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
          this.updatePageNumber(this.pageNumber - 1)
          this.updateFrom(this.from - this.size)
          this.executeSearch()
        }
      },
      nextPage () {
        if ((this.from + this.size) < this.total) {
          this.updatePageNumber(this.pageNumber + 1)
          this.updateFrom(this.from + this.size)
          this.executeSearch()
        }
      },
      firstPage () {
        this.updatePageNumber(1)
        this.updateFrom(0)
        this.executeSearch()
      },
      lastPage () {
        if (this.total <= this.size) {
          return
        }
        let pageCounter = 1
        let fromCounter = 0
        let diff = (this.total - this.size)
        while (fromCounter < diff) {
          pageCounter += 1
          fromCounter += this.size
        }
        if (this.from < diff) {
          this.updatePageNumber(pageCounter)
          this.updateFrom(fromCounter)
          this.executeSearch()
        }
      },
      async addCourseToStream (course) {
        this.loadLogDashboardActivity({action: 'addCourseToStream', page: 'courseResults', link: 'add to stream'})
        // NOTE: Vue.js will not rebind isAddedToStream to :disabled unless we force an update
        // even though this was added in a computed property.
        course.isAddedToStream = true
        this.$forceUpdate()

        let currentSemester = course.academicTerm.split(' ')[0]
        let currentYear = course.academicTerm.split(' ')[1]
        let termCode = this.semesterCodeMap[course.academicTerm]
        const params = {
          courseData: { uuid: course.uuid, title: course.title },
          currentSemester: currentSemester,
          currentYear: currentYear,
          termCode: termCode,
          entityType: 'deliverycontext',
          userRole: this.userRole
        }
        let response = await this.addToMyStream(params)
        if (response) {
          this.notifyWarning('Schedule Conflict! The course you added to your stream conflicts with one or more courses.')
        }
        // NOTE: the following snippet ensures the course list and lock status updates on AddToMyStream.vue
        await this.populateAllStreamCourses({streamUuid: this.selectedStreamUuid, updateTimeStamp: true})
      },
      isCourseInStream (course) {
        let isInStream = false
        let streamCourses = this.semesterCourses
        streamCourses.forEach((streamCourse) => {
          if (course.uuid === streamCourse.uuid) {
            isInStream = true
          }
        })
        return isInStream
      },
      courseHasConflict (course) {
        let hasConflict = false
        if (course.meetingDaysFormatted) {
          course.meetingDaysFormatted.forEach(function (meetingDay) {
            if (meetingDay.conflict) {
              hasConflict = true
            }
          })
        }
        return hasConflict
      },
      navigateToCourse (course) {
        return this.$router.push({ name: 'courseDetail', params: { uuid: course.uuid } })
      },
      processIntructorName (term) {
        if (term.indexOf('_') > -1) {
          return term.substr(0, term.indexOf('_'))
        }
        return term
      },
      showLoader () {
        this.loading = true
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        this.loading = false
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      },
      isTermFilterSelected (facet, fieldName) {
        let valuesToFilter = this.filter[fieldName]
        let fieldValue = facet.key
        return valuesToFilter && valuesToFilter.includes(fieldValue)
      },
      initializeSearchFilter () {
        let filter = this.filter
        Object.values(this.facetFieldMap).forEach(fieldName => {
          filter[fieldName] = []
        })
      }
    },
    computed: {
      ...mapState({
        'query': state => state.advancedSearch.query,
        'results': state => state.advancedSearch.results,
        'sort': state => state.advancedSearch.sort,
        '_source': state => state.advancedSearch._source,
        'from': state => state.advancedSearch.from,
        'size': state => state.advancedSearch.size,
        'pageNumber': state => state.advancedSearch.pageNumber,
        'facets': state => state.advancedSearch.facets,
        'terms': state => state.advancedSearch.terms,
        'department': state => state.advancedSearch.department,
        'subject': state => state.advancedSearch.subject,
        'division': state => state.advancedSearch.division,
        'instructor': state => state.advancedSearch.instructor,
        'major': state => state.advancedSearch.major,
        'unit': state => state.advancedSearch.unit,
        'qr': state => state.advancedSearch.qr,
        'monday': state => state.advancedSearch.monday,
        'tuesday': state => state.advancedSearch.tuesday,
        'wednesday': state => state.advancedSearch.wednesday,
        'thursday': state => state.advancedSearch.thursday,
        'friday': state => state.advancedSearch.firstyear,
        'classTimeFrom': state => state.advancedSearch.classTimeFrom,
        'classTimeTo': state => state.advancedSearch.classTimeTo,
        'firstyear': state => state.advancedSearch.firstyear,
        'lastUpdatedTime': state => state.advancedSearch.lastUpdatedTime,
        'selectedStreamUuid': state => state.advancedSearch.selectedStreamUuid,
        'semester': state => state.advancedSearch.semester,
        'total': state => state.advancedSearch.total,
        'publicLibraryList': state => state.advancedSearch.publicLibraryList,
        'privateLibraryList': state => state.advancedSearch.privateLibraryList,
        'semesterCourses': state => state.semester.courses,
        'streams': state => state.semester.streams,
        'libraryPositionMapping': state => state.search.libraryPositionMapping,
        'packages': state => state.institution.packages,
        'semesterCodeMap': state => state.advancedSearch.semesterCodeMap,
        'userObj': state => state.user.userObj,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      formattedIndexList () {
        let allIndices = this.allIndexes
        return this.joinListWithCommas(allIndices)
      },
      formattedLibraryList () {
        let allFolders = this.allFolders
        return this.joinListWithCommas(allFolders)
      },
      formattedResults () {
        let formatted = []
        let formatDayAndTime = this.getFormattedDayAndTimeStrings
        let results = this.results
        if (!results || results.length <= 0) {
          return formatted
        }
        let isCourseInStream = this.isCourseInStream
        // TODO add instructor field on object
        results.forEach(function (result) {
          let dayAndTimeStrings = formatDayAndTime(result)
          result['uuid'] = result.uuid
          result['section'] = '#' + result['num']
          result['days'] = dayAndTimeStrings['days']
          result['times'] = dayAndTimeStrings['times']
          result['enrollment'] = result['currentSeats'] + '/' + result['maxSeats']
          // TODO in AddToMyStream.vue, when the remove button is clicked, reflect that change here
          if (isCourseInStream(result)) {
            result['isAddedToStream'] = true
          } else {
            result['isAddedToStream'] = false
          }
          formatted.push(result)
        })
        return formatted
      },
      userStreams () {
        let userId = this.userId
        let streams = this.streams
        let userStreams = []
        streams.forEach(function (stream) {
          if (stream.entityType !== 'club' && stream.entityType !== 'event' && stream.ownerId === userId) {
            userStreams.push(stream)
          }
        })
        return userStreams
      },
      planningStream () {
        // NOTE: This assumes a user's planningStream exists and is the first entry in the list
        //       This will be true when a student is uploaded via CSV with the planStream column set
        let streams = this.userStreams
        if (!streams || !streams.length) {
          return {}
        }
        return streams[0]
      },
      isPlanningStreamNull () {
        let planningStream = this.planningStream
        return !planningStream || !planningStream.uuid
      },
      isPlanningStreamLocked () {
        if (!this.isLockStreamEnabled || this.isPlanningStreamNull) {
          return false
        }
        return this.planningStream.isLocked || this.planningStream.locked
      },
      formattedFacets () {
        let formattedFacets = {}
        let facets = this.facets
        let isTermFilterSelected = this.isTermFilterSelected
        let facetFieldMap = this.facetFieldMap
        this.allFacetNames.forEach((facetName) => {
          const fieldName = facetFieldMap[facetName]
          let facetResult = (facets[facetName] && facets[facetName].termObj && facets[facetName].termObj.buckets) ? facets[facetName].termObj.buckets : []
          if (facetResult) {
            facetResult.forEach((termFacet) => {
              termFacet.isSelected = isTermFilterSelected(termFacet, fieldName)
            })
          }
          formattedFacets[facetName] = facetResult
        })
        return formattedFacets
      },
      courseSearchFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.COURSE_SEARCH_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      addToStreamFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.ADD_TO_STREAM_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      formattedSource () {
        let source = [
          'uuid',
          'title',
          'description',
          'creationTime',
          'lastUpdatedTime',
          'type',
          'ancestor',
          'owningLibraryId',
          'ownerName',
          'ownerId',
          'originUuid',
          'thumbnailURIList',
          'appliedTagMap',
          'facetedCourseTags',
          'prerequisites',
          'corequisities',
          'catalogCourseId',
          'level',
          '_score'
        ]
        let flagMap = this.courseSearchFlagMap
        if (!flagMap) {
          return source
        }

        if (flagMap.showEnrollmentOnResult) {
          source.push('maxSeats')
          source.push('currentSeats')
        }
        if (flagMap.showRoomInformationOnResult) {
          source.push('roomInformation')
        }
        if (flagMap.showMeetingDaysOnResult) {
          source.push('meetingDays')
          source.push('meetingDaysRaw')
          source.push('meetingDaysFormatted')
        }
        if (flagMap.showMeetingTimesOnResult) {
          source.push('meetingFromTime')
          source.push('meetingToTime')
        }
        if (flagMap.showSpecialInstructionsOnResult) {
          source.push('specialInstructions')
        }
        if (flagMap.showCRNOnResult) {
          source.push('crn')
        }
        if (flagMap.showDivisionCriteria) {
          source.push('division')
        }
        if (flagMap.showDepartmentCriteria) {
          source.push('department')
          source.push('departmentCode')
        }
        if (flagMap.showSubjectCriteria) {
          source.push('subject')
          source.push('subjectCode')
        }
        if (flagMap.showUnitsCriteria) {
          source.push('maxCredit')
          source.push('minCredit')
          source.push('creditHour')
        }
        if (flagMap.showInstructorCriteria) {
          source.push('instructorNames')
        }
        if (flagMap.showSectionOnResult) {
          source.push('num')
        }
        if (flagMap.showSemesterCriteria) {
          source.push('termCode')
          source.push('term')
          source.push('academicTerm')
        }
        if (flagMap.showTimeCriteria) {
          source.push('timeSlots')
        }
        if (flagMap.showCourseSearchFlagCriteria) {
          source.push('courseFlags')
        }
        if (flagMap.showMajorsCriteria) {
          source.push('courseMajors')
          source.push('courseMajorCodes')
        }
        if (flagMap.showBlockCriteria) {
          source.push('block')
        }
        if (flagMap.showGradeLevelCriteria) {
          source.push('gradeLevel')
        }
        if (flagMap.showYearCriteria) {
          source.push('academicYear')
        }
        return source
      },
      allFacetNames () {
        return Object.keys(this.facetFieldMap)
      },
      advisorDashboardFeature () {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.ADVISTOR_DASHBOARD_FEATURE_ID]
      },
      isLockStreamEnabled () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (!advisorDashboardFeature || !advisorDashboardFeature.enabled) {
          return false
        }
        let lockStreamFlag = PackageUtil.getFlagFromFeature(advisorDashboardFeature, this.lockStreamFlagName)
        if (!lockStreamFlag) {
          return false
        }
        return lockStreamFlag.enabled || lockStreamFlag.isEnabled
      }
    },
    watch: {
      lastUpdatedTime (newTime, oldTime) {
        this.showLoader()
        this.initializeSearchFilter()
        let shouldUpdateFacets = true
        this.executeSearch(shouldUpdateFacets)
      }
    }
  }
</script>

<style scoped>
.conflict {
    color: red
}

.no-conflict {
    color: green
}
</style>



// WEBPACK FOOTER //
// src/app/advancedSearch/components/CourseSearchResults.vue